import * as Utils from "utils/utils";
import * as LogoutConstants from "routes/logout/constants";
import * as React from "react";
import * as FetchConstants from "hooks/use-fetch/constants";
import useFetch from "hooks/use-fetch";
import Loader from "components/loader";

const Logout = () => {
    // Without memoizing this value, useFetch gets called over and over again
    const url = React.useMemo(() => ("api/Authentication/ExpireCookie"), []);

    // Without memoizing this value, useFetch gets called over and over again
    const options = React.useMemo(() => ({
        method: FetchConstants.HTTP_METHOD.POST
    }), []);

    const { loading, error } = useFetch(url, options);

    if (loading) {
        return (
            <Loader />
        );
    }
    else if (error) {
        window.location.href = `${document.referrer}?ssoError=1`;
    }
    else {
        const nextUrl = Utils.getQueryParam(LogoutConstants.QUERY_PARAMETERS.NEXT_URL);
        window.location.href = nextUrl ?? document.referrer;
    }
};

Logout.propTypes = {
    
};

export default Logout;